import React, { Component } from 'react';
import '../../css/VPTOverview.css';
import '../../css/bootstrap.min.css';
import Flex from 'styled-flex-component';
import { VPT_BASE_API_URL, getUrlParameter } from '../../lib/api';

class VPTOverview extends Component {
    state = {
        response: null,
        loading: true,

    }
    async print() {
        window.print();
        // try {
        //     await downloadPDF();
        // } catch (error) {
        //     alert('Failed to download report');
        // }

    }
    componentDidMount() {
        this.getOverview();
    }
    async getOverview() {
        try {
            let user = getUrlParameter('user');
            let rawResponse = await fetch(`${VPT_BASE_API_URL}/test/getTestResults?user=` + user);
            let response = await rawResponse.json();
            if (response.status == 200) {
                this.setState({ response: response, loading: false });
            } else {
                this.setState({ response: null, loading: false, error: 'Something went wrong while fetching your data' });
            }
        } catch (error) {
            console.log(error);
            this.setState({ response: null, loading: false, error: 'Something went wrong while fetching your data' });
        }
    }
    render() {
        let loading = this.state.loading;
        let user = getUrlParameter('user');
        let response = this.state.response;

        if (!user) {
            return <h3 style={{ textAlign: 'center' }}>Not valid token passed</h3>
        }
        if (loading) {
            return <p style={{ textAlign: 'center' }}>Please wait while we fetch your results</p>
        }
        if (!response) {
            return <h3 style={{ textAlign: 'center' }}>Not valid token passed or something went wrong while fetching your results</h3>
        }
        return <>
            <div style={{ backgroundImage: "url(/images/bg.png)", backgroundRepeat: 'no-repeat', padding: '10px' }}>

                <div className="container" style={{ maxWidth: '900px' }}>
                    <div className="whtbg">
                        <Flex justifyBetween alignCenter>
                            <div>
                                <a href="https://www.edwisely.com" target="_blank">
                                    <img height="100" width="100" src="/images/Edwisely_logo.svg" />
                                </a>
                            </div>
                            <div>
                                <a href="#"><p className="printimg" onClick={this.print} style={{ width: '18px', float: 'right' }}><img src="/images/print.png" /></p></a>
                            </div>
                        </Flex>
                        <div style={{ marginTop: "-20px" }}>
                            <Flex justifyBetween  >
                                <div>
                                    <p className="pdtp"><b>Name</b>: {response.user_name}</p>
                                    <p><b>Organization/University</b>: {response.user_company}</p>
                                </div>
                                <div>
                                    <p className="pdtp"><b>Email</b>: {response.user_eamil}</p>
                                    <p><b className="pdbtm">Mobile</b>:{response.user_mobile}</p>
                                </div>
                            </Flex>
                        </div>


                        <hr className="vpt" />
                        <div className="summary">

                            <div className="col-lg-12">
                                <p className="smry">Edwisely Comprehensive Assessment (ECA)</p>
                                <p className="lstcnt smrycnt">Edwisely Comprehensive Assessment gives the test takers a holistic view of their Quantitative and Qualitative abilities.Evaluation of Quantitative abilities is done through the aptitude scores of Quant, Verbal and Logical Reasoning Questions. Qualitative abilities are evaluated using our in-house psychometric models to measure Attention to Detail, Critical Thinking and conscientiousness  </p>
                            </div>
                        </div>

                        <div className="bxs">
                            <div className="col-xs-offset-2">
                                {response.psychometric_traits.map((item, index) => (
                                    <div className={`col-md-4 col-sm-4 col-xs-12 text-center lane1 bxbg clr${index + 1}`}>
                                        <p className="bigtle">{item.value ? parseFloat(item.value).toFixed(0) : "NA"}</p>
                                        <p className="smltle">{item.key}</p>
                                    </div>
                                ))}
                            </div>
                        </div>


                        <div className="lst">
                            <div className="col-md-12 col-xs-12">
                                {
                                    !response.psychometric_traits[0].value && <p className="lstle" style={{ textAlign: "center", margin: "25px auto", maxWidth: "700px" }}><b>We are sorry to inform you that due to insufficent questions answered, your test report could not be generated.</b></p>
                                }
                                <p className="lstle" style={{ marginTop: "20px" }}>Understanding your Test Report:</p>
                                <p className="lstcnt">All scores reported are <b>Percentile Ranks</b> of your performance in that section.</p>
                                <p class="lstcnt">A <b>Percentile</b> (or a centile) is a measure used in statistics indicating the value below which a given percentage of observations in a group of observations falls. The <b>Percentile Rank</b> of a score is the percentage of scores in its frequency distribution that are equal to or lower than it.</p>
                                <p class="lstcnt"><b>For example, If 69 is your percentile rank in Critical Thinking, it implies that you have scored more than 69% of the people who took the test. The same applies for all the other scores.</b></p>
                                <p id="noteImp" className="lstle">Definitions:</p>
                                {response.psychometric_traits.map((item, index) => (
                                    <>
                                        <p className="lsthed">{item.key}:</p>
                                        <p className="lstcnt">{item.text}</p>
                                    </>
                                ))}

                                <p className="lstle" >Important Note:</p>

                                <p className="lsthed">1. The collected data in different scales and ranges is standardized and composite scores are calculated
                                for each of the traits separately
                            </p>
                                <p className="lsthed pdbtm pdbtmcpy">2. We respect your privacy and do not tolerate spam and will never sell, rent, lease or give away your information (name, address, email, etc.) to any third party.</p>

                                <p className="lsthed pdbtm pdbtmcpy text-center" style={{ fontSize: '18px' }}>A copy of the test report has been sent to your email id at {response.user_eamil}</p>
                                <div style={{ textAlign: 'center' }}>
                                    <span><a href="https://www.edwisely.com/privacy.html" target="_blank">Privacy policy </a> &nbsp;&nbsp;&nbsp;&nbsp;
                                <a href="https://www.edwisely.com/tos.html" target="_blank">Terms &amp; Conditions</a></span><br />
                                </div>
                                <p style={{ marginTop: '10px' }} className="cpyrghts">All Rights Reserved. © 2019  Edwisely. Copyright of Hakate Technologies Pvt. LTD</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    }
}

export default VPTOverview;